module.exports = {"623024100":"电尕镇","623024200":"益哇乡","623024201":"卡坝乡","623024202":"达拉乡","623024203":"尼傲乡","623024204":"旺藏乡","623024205":"阿夏乡","623024206":"多儿乡","623024207":"桑坝乡","623024208":"腊子口乡","623024209":"洛大乡","623024400":"国营迭部县林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/623024.json
// module id = 2762
// module chunks = 0